import { ReloadOutlined } from '@ant-design/icons';
import { UsersImporterSlice } from '@hefe/store';
import { Button, Col, Row, Space, Steps, Typography } from 'antd';
import { t } from '@hefe/i18n';
import React from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../store/store';
import UsersImportColumnSelectorComponent from '../users-import-column-selector/users-import-column-selector.component';
import UsersImporterDataImporterComponent from '../users-import-data-importer/users-import-data-importer.component';
import UsersImportSettingsComponent from '../users-import-settings/users-import-settings.component';
import UsersImporterCheckComponent from '../users-importer-check/users-importer-check.component';

export default function UsersImportComponent() {
  const dispatch = useAppDispatch();
  const activeStep = useSelector(
    UsersImporterSlice.usersImporterActiveStepSelector
  );

  const numberOfSteps = 4;

  const resetImporter = () => {
    dispatch(UsersImporterSlice.usersImporterActions.reset());
  };

  const steps = () => {
    const returnValue: any[] = [];
    for (let i = 0; i < numberOfSteps; i += 1) {
      returnValue.push(
        <Steps.Step key={i} title={t(`users_importer.step_${i}`)} />
      );
    }
    return returnValue;
  };

  const stepContent = (step: number) => {
    switch (step) {
      case 0:
        return <UsersImportColumnSelectorComponent />;
      case 1:
        return <UsersImporterDataImporterComponent />;
      case 2:
        return <UsersImportSettingsComponent />;
      case 3:
        return <UsersImporterCheckComponent />;
      default:
        return null;
    }
  };

  return (
    <Row gutter={[0, 30]}>
      <Col xs={24}>
        <Row justify="space-between">
          <Typography.Text>
            {t('users_importer.hint_own_fields')}
          </Typography.Text>
          <Button
            type="primary"
            icon={<ReloadOutlined />}
            onClick={() => resetImporter()}
          >
            {t('reset')}
          </Button>
        </Row>
      </Col>
      <Col xs={24}>
        <Steps current={activeStep} size="small">
          {steps()}
        </Steps>
      </Col>
      <Col xs={24}>{stepContent(activeStep)}</Col>
    </Row>
  );
}
